import styled from "styled-components/macro";

export const GameFooter = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
`;
